import { render, staticRenderFns } from "./Contractor.vue?vue&type=template&id=56d8cc50"
import script from "./Contractor.vue?vue&type=script&lang=js"
export * from "./Contractor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports